// Import modules
import mobileMenu from './modules/mobile-menu.js';
import { modal } from './modules/modal.js';
import { initializeNotification } from './modules/notification.js';
import { spotlight } from './modules/notification-spotlight.js';
import { simulator } from './modules/notification-simulator.js';
import sliders from './modules/sliders.js';
import { Fancybox } from '@fancyapps/ui';
import expandableText from './modules/expandable-text.js';
import gallery from './modules/gallery.js';

// Init functions
function init() {
	// init fancybox
	Fancybox.bind('[data-fancybox]');

	// init mobile menu --> wp-content/themes/expl-theme/source/scripts/modules/mobile-menu.js
	mobileMenu();

	// init modal --> wp-content/themes/expl-theme/source/scripts/modules/modal.js
	modal();

	// init notification spotlight --> wp-content/themes/expl-theme/source/scripts/modules/notification-spotlight.js
	spotlight();

	// init notification simulator --> wp-content/themes/expl-theme/source/scripts/modules/notification-simulator.js
	simulator();

	// init notification --> wp-content/themes/expl-theme/source/scripts/modules/notification.js
	// init notification popup
	document.querySelector('.notification-popup') &&
		initializeNotification('.notification-popup', 'notification-popup', 1000);

	// init notification snackbar
	document.querySelector('.notification-snackbar') &&
		initializeNotification(
			'.notification-snackbar',
			'notification-snackbar',
			2000
		);

	// init sliders --> wp-content/themes/expl-theme/source/scripts/modules/sliders.js
	sliders();

	// init expandable text --> wp-content/themes/expl-theme/source/scripts/modules/expandable-text.js
	expandableText();

	// init gallery --> wp-content/themes/expl-theme/source/scripts/modules/gallery.js
	gallery();

	const allDetails = document.querySelectorAll('details');

	for (const details of allDetails) {
		details.addEventListener('toggle', (e) => {
			if (details.open) {
				for (const otherDetails of allDetails) {
					if (otherDetails !== e.target && otherDetails.open) {
						otherDetails.open = false;
					}
				}
			}
		});
	}
}

// Run the init function when the page loads
window.onload = init;
